import { Controller } from "@hotwired/stimulus";

// On the apply form, default the move-out date to one year after the move-in
// date. Only fills when move-out is still empty so a manual choice isn't
// overwritten. Drives the flatpickr instance so the visible field updates too.
export default class extends Controller {
  static targets = ["moveIn", "moveOut"];

  autofillMoveOut() {
    const moveIn = this.moveInTarget.value;
    if (!moveIn) return;
    if (this.moveOutTarget.value) return;

    const date = new Date(`${moveIn}T00:00:00`);
    if (Number.isNaN(date.getTime())) return;
    date.setFullYear(date.getFullYear() + 1);
    const iso = date.toISOString().slice(0, 10);

    const picker = this.moveOutTarget._flatpickr;
    if (picker) {
      picker.setDate(iso, false);
    } else {
      this.moveOutTarget.value = iso;
    }
  }
}
